export default __webpack_public_path__ + "static/media/DashboardComment.6dcfbfa0.svg";